// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1k-7";
export var adjustableWidthBorderHeld = "_1k-8";
export var arrow = "_1k-3";
export var arrowButton = "_1k-4";
export var headerCell = "_1k-0";
export var help = "_1k-2";
export var icon = "_1k-1";
export var iconWrapper = "_1k-6";
export var noBorder = "_1k-b";
export var nonAdjustableWidthBorder = "_1k-9";
export var nonAdjustableWidthBorderHeld = "_1k-a";
export var textButton = "_1k-5";